import { useMemo } from 'react';
export var useCurrentSelectionStyleType = function useCurrentSelectionStyleType(editorState) {
  return useMemo(function () {
    return editorState.getCurrentContent().getBlockMap().get(editorState.getSelection().getAnchorKey()).getType();
  }, [editorState]);
};